const blue = {
    100: 'rgb(165, 190, 243)',
    200: 'rgb(129, 163, 239)',
    300: 'rgb(93, 137, 234)',
    400: 'rgb(56, 111, 229)',
    500: 'rgb(28, 88, 217)',
    600: 'rgb(23, 73, 181)',
    700: 'rgb(19, 59, 144)',
    800: 'rgb(14, 44, 108)',
};
export default blue;
